import React, { Fragment } from 'react';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import dayjs from 'dayjs';
import isNaN from 'lodash/isNaN';

const PercentageBox = (props) => {
  const {
    percentage,
    assessments,
    assessmentDict,
    labelDescription,
    setAssessmentsPopOverData,
    setIsAssessmentsPopOverOpen,
  } = props;
  let barColor;
  if (!percentage) {
    barColor = '#f1f1f2';
  } else if (percentage <= 24.99) {
    barColor = '#fedb00';
  } else if (percentage <= 49.99) {
    barColor = '#ffec9c';
  } else if (percentage <= 74.99) {
    barColor = '#bff5aa';
  } else if (percentage <= 100) {
    barColor = '#6cc24a';
  }

  const extractData = () => {
    if (isNaN(percentage)) {
      return null;
    }
    const assessmentDictkeysList = Object.keys(assessmentDict);
    const assessmentsScoreData = [];
    assessments.forEach(({ id, title, lastDateScored }) => {
      if (
        assessmentDictkeysList.some(
          (assessmentKey) => assessmentKey === `assessment_${id}`,
        )
      ) {
        assessmentsScoreData.push({
          score: assessmentDict[`assessment_${id}`],
          title: title.replace(/"/g, ''),
          date: dayjs(lastDateScored).format('MM/DD/YY'),
        });
      }
    });

    const assessmentScorePopOverData = {
      labelDescription,
      assessmentsScoreData,
    };
    setAssessmentsPopOverData(assessmentScorePopOverData);
    setIsAssessmentsPopOverOpen(true);
  };

  return (
    <Fragment>
      <div className="percentage-box flex items-center">
        <span style={{ backgroundColor: barColor }}>
          {!isNaN(percentage) ? `${percentage}%` : 'NA'}
        </span>
        <span className="cursor-pointer">
          <Icon onClick={() => extractData()} id="see_more_assessment_report" />
        </span>
      </div>
    </Fragment>
  );
};

export default PercentageBox;
